import type { FC, InputHTMLAttributes, ReactNode } from 'react'

import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import { controlClasses } from '@/components/generals/form-field'

// Password field with a show and hide toggle
export const PasswordInput: FC<InputHTMLAttributes<HTMLInputElement>> = ({ className, ...props }): ReactNode => {
    const [visible, setVisible] = useState(false)

    return (
        <div className='relative'>
            <input
                {...props}
                type={visible ? 'text' : 'password'}
                className={cn(controlClasses, 'h-12 pr-12', className)}
            />

            <button
                type='button'
                onClick={() => setVisible(current => !current)}
                aria-label={visible ? 'Hide password' : 'Show password'}
                aria-pressed={visible}
                className='absolute right-1.5 top-1/2 inline-flex size-9 -translate-y-1/2 items-center justify-center rounded-lg text-charcoal/50 transition-colors hover:bg-charcoal/5 hover:text-charcoal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest'
            >
                {visible ? <EyeOff aria-hidden='true' className='size-4' /> : <Eye aria-hidden='true' className='size-4' />}
            </button>
        </div>
    )
}
